export default "__VITE_PUBLIC_ASSET__64e38851__"